'use strict';

// Declare app level module which depends on views, and components
 var App =   angular.module('myApp', [
     'ngRoute',
     'myApp.homepage',
     'myApp.rides',
     'myApp.fireestimate',
     'myApp.careers',
     'myApp.version',
     'myApp.orderHistory',
     'myApp.menus',
     'myApp.aboutUs',
     'myApp.mediaKit',
     'myApp.investors',
     'myApp.restaurant',
     'myApp.newsRoom',
     'myApp.fatafat',
     'myApp.delivery',
     'myApp.askLocal',
     'myApp.offers',
     'myApp.terms',
     'myApp.partner',
     'myApp.sitemap',
     'ngMaterial',
     'updateMeta'


])
 
 App.filter('dashFilter', function() {
	return function(input) {
		 return input.replace(/[^a-zA-Z0-9 ]/g, "").replace(/ /g,'-').replace('--','-');
       
	}
})

App.filter('reversedashFilter', function() {
    return function(input) {
         return input.replace('-',' ');
       
    }
})
  App.filter('timeFormat', function() {
    return function(input) {
		
        var hours = input[0] + input[1];
        var min = input[3] + input[4];
        if (hours < 12) {
            return hours + ':' + min + 'am';
        } else {
            hours=hours - 12;
            hours=(hours.length < 10) ? '0'+hours:hours;
            return hours+ ':' + min + 'pm';
		}
	}
})

App.filter('formatTime',[ '$filter', function ($filter) {
          return function (time, format) {
              var parts = time.split(':');
              var date = new Date(0, 0, 0, parts[0], parts[1], parts[2]);
              return $filter('date')(date, format || 'h:mm a');
          };
      }]);
  
App.filter('camelCase', function() {
    return function(input) {
        return input.charAt(0).toUpperCase() +   input.substr(1).toLowerCase();
    }
})

App.run(['$rootScope','$http', function($rootScope,$http) {
    
    
    $http.get('https://ipconfig.tookanapp.com/requestCountryCodeGeoIP2').then(function(data) {
        
        if(data.data.data.country_code == 'IN') {
           $rootScope.iframeView = false;
           document.getElementById('footer').style.display = 'block'
        }
        else {
            $rootScope.iframeView = true;
            document.getElementById('footer').style.display = 'none'
        }
       
             
    })
    .catch(function(error) {
        $rootScope.iframeView = false;
        document.getElementById('footer').style.display = 'block'
    });   



    window.fbAsyncInit = function() {
        FB.init({
            appId      : '782131025144439',
            xfbml      : true,
            version    : 'v2.11'
        });
        FB.AppEvents.logPageView();
    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    gapi.load('auth2', function(){
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        var auth2 = gapi.auth2.init({
            client_id: '506849624961-c9bbl632kfgtvqcq2b55rubibcnpnfhg.apps.googleusercontent.com',
            cookiepolicy: 'single_host_origin'
            // Request scopes in addition to 'profile' and 'email'
            //scope: 'additional_scope'
        });
    });

}])

 
 
App.controller('MainController',['$rootScope','$scope','login','$location','API','$timeout','$window' ,function ($rootScope,$scope,login,$location,API,$timeout,$window) {

    $rootScope.loading_custom = false;
    $scope.form = {
        myForm: {}
    };
    $rootScope.singapore_policy = false;

    $rootScope.openlogin = function () {
        $('#login').modal('show');
        var element = document.getElementById('customBtnGoogle');
        if(element.id) {
            setTimeout(function () {
                $scope.attachSignin();
            }, 200)
        }
    }

    var h1 = $(document).height(),h2=window.innerHeight;
    $("#number").keypress(function(event) {
        if (event.which == 13) {
            sendSms();
        }
    });
     $scope.sendSms = function(){
        var inputtxt = $scope.driverPhone;
        console.log(inputtxt)
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if(inputtxt.match(phoneno)) {
            console.log("correct number")
            document.getElementById("error").innerHTML=""
            document.getElementById("success").innerHTML="Sending SMS...";
            $(".error").css('display','none');
            $(".success").css('display','block');
            $("#link").css('display','none')
        }
        else {
            console.log("incorrect number");
            document.getElementById("success").innerHTML="";
            document.getElementById("error").innerHTML="Incorrect Number!";
            $(".error").css('display','block');
            $("#link").css('display','block');
            $(".success").css('display','none');
            return;
        }
        API.post("https://prod-autos-api.jugnoo.in/send_app_link_sms_from_website", {
            phone_no:inputtxt,
            is_driver : 1
        }).then(function(data ) {
            if (data.data.flag == 143) {
                document.getElementById("success").innerHTML = "App download link sent to your number. Download the App and Chalo Jugnoo Se!";
                ga('send', 'event', 'getapp', 'success');
            }
            else {
                document.getElementById("success").innerHTML = data.data.message;
                ga('send', 'event', 'getapp', 'fail');
            }
        })
    }

    $rootScope.userLocation = localStorage.getItem('userLocation');
    $scope.$on('$routeChangeStart', function($event, next, current) {


        var url = $location.path()
        var a = url.indexOf('/rides') ;
        var b =  url.indexOf('/fatafat');
        var nofound = url.indexOf('/404')
        if(url.indexOf('/sg')!= -1)
            $rootScope.show_singapore_footer = true;
        else
            $rootScope.show_singapore_footer = false;
        if(a!=-1||b!=-1 || nofound!=-1 || url.indexOf('/not-available')!= -1){
            $rootScope.showlocation= true;
            // $scope.$apply();
        }
        else{
            $rootScope.showlocation=false;
            // $scope.$apply();
        }
        if(current)
            $rootScope.singapore_policy = current.$$route.originalPath == '/sg' ? true : false;

    });

    $scope.toggleOtp = function () {
        document.getElementById("myForm").reset();
        document.getElementById("myotpForm").reset();
        $scope.otperror = "";
        $scope.showOtpDiv= false;
    }

    $(document).on('hidden.bs.modal','#login', function () {
        $timeout(function () {
            $scope.phone = null;
            $scope.otp="";
        })
            $scope.error = "";
            $scope.otperror = "";
            $scope.showOtpDiv= false;
        $scope.form.myForm.$setPristine();
        document.getElementById("myForm").reset();
        document.getElementById("myotpForm").reset();


    })







    $scope.showOtpDiv = false;
    $scope.phoneNumber = /^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/;



    if(localStorage.getItem("accessToken")) {
        API.post(fatafat_base_url+"v1/customer/login_using_access_token", {

            "access_token": localStorage.getItem("accessToken") ,
            "app_version": 233,
            "country": "",
            "device_name": "iPad Simulator",
            "device_token": "",
            "device_type": 2,
            "is_access_token_new": 1,
            "last_push_time_diff": "-1",
            "os_version": "9.3",
            "unique_device_id": ""


        }).then(function (result) {


            if(result.data.flag == 407) {
                localStorage.setItem('userDetails', JSON.stringify(result.data.login));
                $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails'));
                localStorage.setItem('userIdentifier', result.data.login.user_identifier);
                window.fuguUpdate({
                    appSecretKey: fuguKey,
                    color: "#ff742c",
                    uniqueId: result.data.login.user_identifier,
                    email: result.data.login.user_email,
                    name: result.data.login.user_name,
                    phone: result.data.login.phone_no
                });

                if (result.data.tagged_addresses) {
                    localStorage.setItem('savedAddresses', JSON.stringify(result.data.login.tagged_addresses));
                }
                $rootScope.showName = true;
                $('#login').modal('hide');
                $scope.showOtpDiv = false;
            }
            else{
                $window.localStorage.clear();
                $rootScope.showName = false;
                if(typeof(window.shutDownFugu()) == 'function') {
                    window.shutDownFugu();
                }
            }

        })
    }
    else{
        $rootScope.showName = false;

    }

    var auth2;
    var startApp = function() {
        gapi.load('auth2', function(){
            // Retrieve the singleton for the GoogleAuth library and set up the client.
            auth2 = gapi.auth2.init({
                client_id: '506849624961-c9bbl632kfgtvqcq2b55rubibcnpnfhg.apps.googleusercontent.com',
                cookiepolicy: 'single_host_origin'
                // Request scopes in addition to 'profile' and 'email'
                //scope: 'additional_scope'
            });
        });
    };

    $scope.attachSignin=function() {
        var element = document.getElementById('customBtnGoogle');
        console.log(element.id);
        auth2.attachClickHandler(element, {},
            function (googleUser) {




                    console.log(googleUser);
                var googleAccessToken = googleUser.Zi.id_token;
                var user_name = googleUser.w3.ig;
                var user_emailId = googleUser.w3.U3;
                var user_google_id = googleUser.w3.Eea;


                API.post(fatafat_base_url+"v1/customer/login_using_google", {

                    google_access_token: googleAccessToken,
                    app_version: 233,
                    //'fb_mail': $scope.authResponse.userID + '@facebook.com',
                    country: "",
                    device_name: "iPad Simulator",
                    device_token: "",
                    device_type: 2,
                    is_access_token_new: 1,
                    last_push_time_diff: "-1",
                    os_version: "9.3",
                    unique_device_id: ""


                }).then(function (result) {
                    if( result.data.flag == 404 || result.data.flag  == 405) {
                        $scope.error = "Enter your Phone No to continue";
                    }
                    else
                    {
                        $scope.error="";
                        localStorage.setItem('accessToken', result.data.login.access_token);
                        $rootScope.showName = true;
                        localStorage.setItem('userDetails', JSON.stringify(result.data.login));
                        localStorage.setItem('userIdentifier', result.data.login.user_identifier);
                        $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails'))
                        window.fuguUpdate({
                            appSecretKey: fuguKey,
                            color:"#ff742c",
                            uniqueId: result.data.login.user_identifier,
                            email: result.data.login.user_email,
                            name: result.data.login.user_name,
                            phone: result.data.login.phone_no
                        });

                        if (result.data.login.tagged_addresses) {
                            localStorage.setItem('savedAddresses', JSON.stringify(result.data.login.tagged_addresses));
                        }

                        $('#login').modal('hide');
                    }
                })
            });
    }
    startApp();

    function onSignIn(googleUser) {
        var id_token = googleUser.getAuthResponse().id_token;
        var profile = googleUser.getBasicProfile();
        console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
        console.log('Name: ' + profile.getName());
        console.log('Image URL: ' + profile.getImageUrl());
        console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.

        API.post(fatafat_base_url+"v1/customer/login_using_google", {

            google_access_token: id_token,
            app_version: 233,
            //'fb_mail': $scope.authResponse.userID + '@facebook.com',
            country: "",
            device_name: "iPad Simulator",
            device_token: "",
            device_type: 2,
            is_access_token_new: 1,
            last_push_time_diff: "-1",
            os_version: "9.3",
            unique_device_id: ""


        }).then(function (result) {

            if(result.data.flag == 148 || result.data.flag == 404 || result.data.flag  == 405) {
                $scope.error = "Enter your phone No. to continue";
            }
            else    {

                $scope.error="";
                localStorage.setItem('accessToken', result.data.login.access_token);
                $rootScope.showName = true;
                localStorage.setItem('userDetails', JSON.stringify(result.data.login));
                localStorage.setItem('userIdentifier', result.data.login.user_identifier);
                $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails'))
                window.fuguUpdate({
                    appSecretKey: fuguKey,
                    color:"#ff742c",
                    uniqueId: result.data.login.user_identifier,
                    email: result.data.login.user_email,
                    name: result.data.login.user_name,
                    phone: result.data.login.phone_no
                });

                if (result.data.login.tagged_addresses) {
                    localStorage.setItem('savedAddresses', JSON.stringify(result.data.login.tagged_addresses));
                }

                $('#login').modal('hide');
            }


        })

    }


    $scope.registerWithFacebook = function () {

        FB.login(function (response) {
            console.log(response)
            if (response.authResponse) {
                $scope.authResponse = response.authResponse;
                console.log(response.authResponse);
                FB.api('/me', function(response) {
                    console.log('Good to see you, ' + response.name + '.');
                    $scope.fb_name = response.name;
                    console.log($scope.fb_name);
                    $rootScope.showLoader = true;
                    console.log($scope.fb_name);
                    console.log(response);
                    API.post(fatafat_base_url + "v1/customer/login_using_facebook", {

                        user_fb_id: $scope.authResponse.userID,
                        user_fb_name: $scope.fb_name,
                        fb_access_token: $scope.authResponse.accessToken,
                        //'fb_mail': $scope.authResponse.userID + '@facebook.com',
                        app_version: 233,
                        country: "",
                        device_name: "iPad Simulator",
                        device_token: "",
                        device_type: 2,
                        is_access_token_new: 1,
                        last_push_time_diff: "-1",
                        os_version: "9.3",
                        unique_device_id: ""


                    }).then(function (result) {

                        if(result.data.flag == 148 || result.data.flag == 404 || result.data.flag  == 405) {
                            $scope.error = res.data.error;
                        }
                        else    {

                            $scope.error="";
                            localStorage.setItem('accessToken', result.data.login.access_token);
                            $rootScope.showName = true;
                            localStorage.setItem('userDetails', JSON.stringify(result.data.login));
                            localStorage.setItem('userIdentifier', result.data.login.user_identifier);
                            $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails'))
                            window.fuguUpdate({
                                appSecretKey: fuguKey,
                                color:"#ff742c",
                                uniqueId: result.data.login.user_identifier,
                                email: result.data.login.user_email,
                                name: result.data.login.user_name,
                                phone: result.data.login.phone_no
                            });

                            if (result.data.login.tagged_addresses) {
                                localStorage.setItem('savedAddresses', JSON.stringify(result.data.login.tagged_addresses));
                            }

                            $('#login').modal('hide');
                        }
                    })

                });
            } else {
            }
        });

    }


    $scope.loginUsingOtp = function(resend) {
            $scope.phoneNo = document.getElementById('phoneNumber').value;
            if($scope.phoneNo && $scope.phoneNumber.test($scope.phoneNo)) {

                API.post(fatafat_base_url + "v1/customer/generate_inhouse_login_otp", {
                    phone_no: "+91" + $scope.phoneNo,
                    country: "",
                    device_name: "",
                    device_token: "",
                    os_version: "9.3",
                    unique_device_id: "",


                }).then(function (result) {
                    if (result.data.flag == 143) {
                        $scope.showOtpDiv = true;
                        $scope.error = "" ;
                        $scope.otperror = resend ? "otp has been sent successfully" : "";
                    }
                    else {
                        $scope.error = res.data.error;
                    }


                });
            }
            else if($scope.phoneNo && !$scope.phoneNumber.test($scope.phoneNo)){

                $scope.error = "Phone number is not valid";

            }
            else {
                $scope.error = "Phone number is required";
            }

    }

    $scope.goback = function(){
        $scope.phNo="";
        $scope.showOtpDiv = false;
    }


    $scope.verifyOtp = function() {
        var otp = document.getElementById('otp').value;
        if(otp) {

            API.post(fatafat_base_url + "v1/customer/verify_inhouse_otp", {
                phone_no: "+91" + $scope.phoneNo,
                login_otp: otp,
                login_type: 0,
                country: "",
                device_name: "",
                device_token: "",
                os_version: "9.3",
                unique_device_id: "",


            }).then(function (result) {
                if (result.data.flag == 407) {
                    $scope.otperror = ""
                    localStorage.setItem('accessToken', result.data.login.access_token);
                    $rootScope.showName = true;
                    localStorage.setItem('userDetails', JSON.stringify(result.data.login));
                    localStorage.setItem('userIdentifier', result.data.login.user_identifier);
                    $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails'))
                    window.fuguUpdate({
                        appSecretKey: fuguKey,
                        color: "#ff742c",
                        uniqueId: result.data.login.user_identifier,
                        email: result.data.login.user_email,
                        name: result.data.login.user_name,
                        phone: result.data.login.phone_no
                    });

                    if (result.data.login.tagged_addresses) {
                        localStorage.setItem('savedAddresses', JSON.stringify(result.data.login.tagged_addresses));
                    }

                    $('#login').modal('hide');
                    $scope.showOtpDiv = false;
                    $scope.form.myForm.$setPristine();
                }
                else {
                    $scope.otperror = result.data.error;
                }


            });

        }
        else{
            $scope.otperror="Please enter 4-digit OTP"
        }
    }
}])


App.config(['$locationProvider', '$routeProvider', function($locationProvider,$routeProvider,$routeParams) {
 
     $locationProvider.html5Mode(true);
     $locationProvider.hashPrefix('!');
    
    $routeProvider.when('/404', {
    templateUrl: 'components/views/notfound.html',
    controller: 'MainController'
    })
    $routeProvider.when('/not-available', {
        templateUrl: 'components/views/notAvailable.html',
        controller: 'MainController'
    })
    $routeProvider.when('/get-driver-app', {
        templateUrl: 'components/views/getDriverApp.html',
        controller: 'MainController'
    })

    $routeProvider.when('/platform', {
        redirectTo: function() {
            window.location = 'https://www.jugnoo.in/taxihawk/';
        }
    })
    $routeProvider.when('/jugnoorental', {
        redirectTo: function() {
            window.location = 'https://www.jugnoo.in/car-rental/';
        }
    })
    $routeProvider.when('/taxihawk', {
        redirectTo: function() {
            window.location = 'https://www.jugnoo.in/jugnootaxi/';
        }
    })
    $routeProvider.when('/menus/:selectedCity/restaurants/:id/:namecity', {
        redirectTo: '/fatafat/:selectedCity/restaurants/:id/:namecity'
    })
    $routeProvider.when('/taxihawk', {
        redirectTo: '/taxihawk/'
    })
    $routeProvider.when('/menus/:selectedCity/restaurants/', {
        redirectTo: '/fatafat/:selectedCity/restaurants'
    })
    $routeProvider.when('/menus/:selectedCity', {
        redirectTo: '/fatafat/:selectedCity'
    })
    $routeProvider.when('/menus', {
        redirectTo: '/fatafat'
    })
    $routeProvider.when('/business' ,{
        redirectTo: '/business/delivery'
    });
    $routeProvider.when('/business/:city' ,{
        redirectTo: '/business/delivery/:city'
    });


    $routeProvider.otherwise({ redirectTo: '/' })
    
}])
App.factory('googlePlacesApi', ['$window', function ($window) {
        if (!$window.google) throw 'Global `google` var missing. Did you forget to include the places API script?';

        return $window.google;
}])


App.directive('googleplace',
    [ '$parse', '$compile', '$timeout', '$document', 'googlePlacesApi',
        function ($parse, $compile, $timeout, $document, google) {

            return {
                restrict: 'A',
                require: '^ngModel',
                scope: {
                    model: '=ngModel',
                    options: '=?',
                    forceSelection: '=?',
                    customPlaces: '=?',
                    onAddressChange: '&'
                },
                controller: ['$scope', function ($scope) {}],
                link: function ($scope, element, attrs, controller) {
                    var keymap = {
                            tab: 9,
                            enter: 13,
                            esc: 27,
                            up: 38,
                            down: 40
                        },
                        hotkeys = [keymap.tab, keymap.enter, keymap.esc, keymap.up, keymap.down],
                        autocompleteService = new google.maps.places.AutocompleteService(),
                        placesService = new google.maps.places.PlacesService(element[0]);

                    (function init() {
                        $scope.query = '';
                        $scope.predictions = [];
                        $scope.input = element;
                        // $scope.options = $scope.options || {};
                        var defaultBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(attrs.lat, attrs.long),
                            new google.maps.LatLng(attrs.lat, attrs.long)
                        );
                        $scope.options = {
                            bounds: defaultBounds
                        };
                        initAutocompleteDrawer();
                        initEvents();
                        initNgModelController();
                    }());

                    function initEvents() {
                        element.bind('keydown', onKeydown);
                        element.bind('blur', onBlur);
                        element.bind('submit', onBlur);

                        $scope.$watch('selected', select);
                    }

                    function initAutocompleteDrawer() {
                        // Drawer element used to display predictions
                        var drawerElement = angular.element('<div g-places-autocomplete-drawer></div>'),
                            body = angular.element($document[0].body),
                            $drawer;

                        drawerElement.attr({
                            input: 'input',
                            query: 'query',
                            predictions: 'predictions',
                            active: 'active',
                            selected: 'selected'
                        });

                        $drawer = $compile(drawerElement)($scope);
                        body.append($drawer);  // Append to DOM

                        $scope.$on('$destroy', function() {
                            $drawer.remove();
                        });
                    }

                    function initNgModelController() {
                        controller.$parsers.push(parse);
                        controller.$formatters.push(format);
                        controller.$render = render;
                    }

                    function onKeydown(event) {
                        if ($scope.predictions.length === 0 || indexOf(hotkeys, event.which) === -1) {
                            return;
                        }

                        event.preventDefault();

                        if (event.which === keymap.down) {
                            $scope.active = ($scope.active + 1) % $scope.predictions.length;
                            $scope.$digest();
                        } else if (event.which === keymap.up) {
                            $scope.active = ($scope.active ? $scope.active : $scope.predictions.length) - 1;
                            $scope.$digest();
                        } else if (event.which === 13 || event.which === 9) {
                            if ($scope.forceSelection) {
                                $scope.active = ($scope.active === -1) ? 0 : $scope.active;
                            }

                            $scope.$apply(function () {
                                $scope.selected = $scope.active;

                                if ($scope.selected === -1) {
                                    clearPredictions();
                                }
                            });
                        } else if (event.which === 27) {
                            $scope.$apply(function () {
                                event.stopPropagation();
                                clearPredictions();
                            });
                        }
                    }

                    function onBlur(event) {
                        if ($scope.predictions.length === 0) {
                            return;
                        }

                        if ($scope.forceSelection) {
                            $scope.selected = ($scope.selected === -1) ? 0 : $scope.selected;
                        }

                        $scope.$digest();

                        $scope.$apply(function () {
                            if ($scope.selected === -1) {
                                clearPredictions();
                            }
                        });
                    }

                    function select() {
                        var prediction;

                        prediction = $scope.predictions[$scope.selected];
                        if (!prediction) return;

                        if (prediction.is_custom) {
                            $scope.$apply(function () {
                                $scope.model = prediction.place;
                                $scope.$emit('g-places-autocomplete:select', prediction.place);
                                console.lo
                                $timeout(function () {
                                    controller.$viewChangeListeners.forEach(function (fn) { fn(); });
                                });
                            });
                        } else {
                            $scope.onAddressChange();
                            $scope.model = prediction.description;
                            attrs.$set('place_id',prediction.place_id)
                            $timeout(function () {
                                controller.$viewChangeListeners.forEach(function (fn) { fn(); });
                            });
                            //placesService.getDetails({ placeId: prediction.place_id }, function (place, status) {
                            //    if (status == google.maps.places.PlacesServiceStatus.OK) {
                            //        $scope.$apply(function () {
                            //            $scope.model = place;
                            //            $scope.$emit('g-places-autocomplete:select', place);
                            //            $timeout(function () {
                            //                controller.$viewChangeListeners.forEach(function (fn) { fn(); });
                            //            });
                            //        });
                            //    }
                            //});
                        }

                        clearPredictions();
                    }
                    var timeoutRef;
                    function parse(viewValue) {
                        var request;

                        if (!(viewValue && isString(viewValue))) return viewValue;

                        $scope.query = viewValue;

                        request = angular.extend({ input: viewValue }, $scope.options);

                        if(timeoutRef) $timeout.cancel(timeoutRef);

                        timeoutRef = $timeout(function () {

                           /* logGoogleData(attrs.location,'autocomplete_api',element.val());*/

                            autocompleteService.getPlacePredictions(request, function (predictions, status) {
                                $scope.$apply(function () {
                                    var customPlacePredictions;

                                    clearPredictions();

                                    if ($scope.customPlaces) {
                                        customPlacePredictions = getCustomPlacePredictions($scope.query);
                                        $scope.predictions.push.apply($scope.predictions, customPlacePredictions);
                                    }

                                    if (status == google.maps.places.PlacesServiceStatus.OK) {
                                        $scope.predictions.push.apply($scope.predictions, predictions);
                                    }

                                    if ($scope.predictions.length > 5) {
                                        $scope.predictions.length = 5;  // trim predictions down to size
                                    }
                                });
                            });
                        },800)

                        if ($scope.forceSelection) {
                            return controller.$modelValue;
                        } else {
                            return viewValue;
                        }
                    }

                    function format(modelValue) {
                        var viewValue = "";

                        if (isString(modelValue)) {
                            viewValue = modelValue;
                        } else if (isObject(modelValue)) {
                            viewValue = modelValue.formatted_address;
                        }

                        return viewValue;
                    }

                    function render() {
                        return element.val(controller.$viewValue);
                    }

                    function clearPredictions() {
                        $scope.active = -1;
                        $scope.selected = -1;
                        $scope.predictions = [];
                    }

                    function getCustomPlacePredictions(query) {
                        var predictions = [],
                            place, match, i;

                        for (i = 0; i < $scope.customPlaces.length; i++) {
                            place = $scope.customPlaces[i];

                            match = getCustomPlaceMatches(query, place);
                            if (match.matched_substrings.length > 0) {
                                predictions.push({
                                    is_custom: true,
                                    custom_prediction_label: place.custom_prediction_label || '(Custom Non-Google Result)',  // required by https://developers.google.com/maps/terms § 10.1.1 (d)
                                    description: place.formatted_address,
                                    place: place,
                                    matched_substrings: match.matched_substrings,
                                    terms: match.terms
                                });
                            }
                        }

                        return predictions;
                    }

                    function getCustomPlaceMatches(query, place) {
                        var q = query + '',  // make a copy so we don't interfere with subsequent matches
                            terms = [],
                            matched_substrings = [],
                            fragment,
                            termFragments,
                            i;

                        termFragments = place.formatted_address.split(',');
                        for (i = 0; i < termFragments.length; i++) {
                            fragment = termFragments[i].trim();

                            if (q.length > 0) {
                                if (fragment.length >= q.length) {
                                    if (startsWith(fragment, q)) {
                                        matched_substrings.push({ length: q.length, offset: i });
                                    }
                                    q = '';  // no more matching to do
                                } else {
                                    if (startsWith(q, fragment)) {
                                        matched_substrings.push({ length: fragment.length, offset: i });
                                        q = q.replace(fragment, '').trim();
                                    } else {
                                        q = '';  // no more matching to do
                                    }
                                }
                            }

                            terms.push({
                                value: fragment,
                                offset: place.formatted_address.indexOf(fragment)
                            });
                        }

                        return {
                            matched_substrings: matched_substrings,
                            terms: terms
                        };
                    }

                    function isString(val) {
                        return Object.prototype.toString.call(val) == '[object String]';
                    }

                    function isObject(val) {
                        return Object.prototype.toString.call(val) == '[object Object]';
                    }

                    function indexOf(array, item) {
                        var i, length;

                        if (array === null) return -1;

                        length = array.length;
                        for (i = 0; i < length; i++) {
                            if (array[i] === item) return i;
                        }
                        return -1;
                    }

                    function startsWith(string1, string2) {
                        return toLower(string1).lastIndexOf(toLower(string2), 0) === 0;
                    }

                    function toLower(string) {
                        return (string === null) ? "" : string.toLowerCase();
                    }
                }
            };
        }
    ])
    App.directive('gPlacesAutocompleteDrawer', ['$window', '$document', function ($window, $document) {
        var TEMPLATE = [
            '<div class="pac-container" ng-if="isOpen()" ng-style="{top: position.top+\'px\', left: position.left+\'px\', width: position.width+\'px\'}" style="display: block;" role="listbox" aria-hidden="{{!isOpen()}}">',
            '  <div class="pac-item" g-places-autocomplete-prediction index="$index" prediction="prediction" query="query"',
            '       ng-repeat="prediction in predictions track by $index" ng-class="{\'pac-item-selected\': isActive($index) }"',
            '       ng-mouseenter="selectActive($index)" ng-click="selectPrediction($index)" role="option" id="{{prediction.id}}">',
            '  </div>',
            '</div>'
        ];

        return {
            restrict: 'A',
            scope:{
                input: '=',
                query: '=',
                predictions: '=',
                active: '=',
                selected: '='
            },
            template: TEMPLATE.join(''),
            link: function ($scope, element) {
                element.bind('mousedown', function (event) {
                    event.preventDefault();  // prevent blur event from firing when clicking selection
                });

                $window.onresize = function () {
                    $scope.$apply(function () {
                        $scope.position = getDrawerPosition($scope.input);
                    });
                };

                $scope.isOpen = function () {
                    return $scope.predictions.length > 0;
                };

                $scope.isActive = function (index) {
                    return $scope.active === index;
                };

                $scope.selectActive = function (index) {
                    $scope.active = index;
                };

                $scope.selectPrediction = function (index) {
                    $scope.selected = index;
                };

                $scope.$watch('predictions', function () {
                    $scope.position = getDrawerPosition($scope.input);
                }, true);

                function getDrawerPosition(element) {
                    var domEl = element[0],
                        rect = domEl.getBoundingClientRect(),
                        docEl = $document[0].documentElement,
                        body = $document[0].body,
                        scrollTop = $window.pageYOffset || docEl.scrollTop || body.scrollTop,
                        scrollLeft = $window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

                    return {
                        width: rect.width,
                        height: rect.height,
                        top: rect.top + rect.height + scrollTop,
                        left: rect.left + scrollLeft
                    };
                }
            }
        };
    }])

    App.directive('gPlacesAutocompletePrediction', [function () {
        var TEMPLATE = [
            '<span class="pac-icon pac-icon-marker"></span>',
            '<span class="pac-item-query" ng-bind-html="prediction | highlightMatched"></span>',
            '<span ng-repeat="term in prediction.terms | unmatchedTermsOnly:prediction">{{term.value | trailingComma:!$last}}&nbsp;</span>',
            '<span class="custom-prediction-label" ng-if="prediction.is_custom">&nbsp;{{prediction.custom_prediction_label}}</span>'
        ];

        return {
            restrict: 'A',
            scope:{
                index:'=',
                prediction:'=',
                query:'='
            },
            template: TEMPLATE.join('')
        };
    }])

     App.filter('highlightMatched', ['$sce', function ($sce) {
            return function (prediction) {
                var matchedPortion = '',
                    unmatchedPortion = '',
                    matched;

                if (prediction.matched_substrings.length > 0 && prediction.terms.length > 0) {
                    matched = prediction.matched_substrings[0];
                    matchedPortion = prediction.terms[0].value.substr(matched.offset, matched.length);
                    unmatchedPortion = prediction.terms[0].value.substr(matched.offset + matched.length);
                }

                return $sce.trustAsHtml('<span class="pac-matched">' + matchedPortion + '</span>' + unmatchedPortion);
            };
        }])

     App.filter('unmatchedTermsOnly', [function () {
            return function (terms, prediction) {
                var i, term, filtered = [];

                for (i = 0; i < terms.length; i++) {
                    term = terms[i];
                    if (prediction.matched_substrings.length > 0 && term.offset > prediction.matched_substrings[0].length) {
                        filtered.push(term);
                    }
                }

                return filtered;
            };
        }])

    App.filter('trailingComma', [function () {
             return function (input, condition) {
                 return (condition) ? input + ',' : input;
             };
    }]);





 